(() => {
  const root = document.getElementById('nads-cart');
  if (!root || window.NadsCart) return;
  const cfg = JSON.parse(root.querySelector('[data-nsc-config]').textContent);
  const body = root.querySelector('[data-nsc-body]');
  const foot = root.querySelector('[data-nsc-foot]');
  const totalEl = root.querySelector('[data-nsc-total]');
  const errEl = root.querySelector('[data-nsc-err]');
  const discEl = document.createElement('div');
  foot.insertBefore(discEl, foot.firstChild);
  root.style.zIndex = '2147483646';
  const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  const rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1) || 1;
  const threshold = Math.round(cfg.threshold * rate);
  const shipThreshold = Math.round((cfg.shipThreshold || 0) * rate);
  const guideThreshold = Math.round((cfg.guideThreshold || 0) * rate);
  const giftId = cfg.gift ? cfg.gift.id : null;
  const guideId = cfg.guide ? cfg.guide.id : null;
  const eligible = new Set(cfg.eligible || []);
  const onCartPage = /\/cart\/?$/.test(location.pathname);
  const GUIDE_OFF = 'nsc-guide-removed';
  let cart = null;
  let busy = false;
  let internal = 0; // our own cart requests in flight
  let changed = false; // set when enforceGifts changed the cart

  const L = '{' + '{', R = '}' + '}';
  const money = (cents, noZero) => {
    const fmt = cfg.moneyFormat || '${{amount}}';
    const a = fmt.indexOf(L), b = fmt.indexOf(R);
    const n = (cents || 0) / 100;
    if (a < 0 || b < 0) return '$' + n.toFixed(2);
    const k = fmt.slice(a + 2, b).trim();
    let v;
    if (k === 'amount_no_decimals') v = Math.round(n).toLocaleString('en-US');
    else if (k === 'amount_with_comma_separator') v = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    else if (k === 'amount_no_decimals_with_comma_separator') v = Math.round(n).toLocaleString('de-DE');
    else if (k === 'amount_with_apostrophe_separator') v = n.toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else v = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (noZero) v = v.replace(/[.,]00$/, '');
    return (fmt.slice(0, a) + v + fmt.slice(b + 2)).replace(/<[^>]*>/g, '');
  };
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const img = (u, w) => !u ? '' : u + (u.includes('?') ? '&' : '?') + 'width=' + (w || 200);
  const store = {
    get: k => { try { return sessionStorage.getItem(k); } catch (_) { return null; } },
    set: (k, v) => { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (_) {} }
  };

  const api = async (path, data) => {
    internal++;
    try {
      const r = await fetch(base + path, data ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) } : { headers: { Accept: 'application/json' } });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
      return j;
    } finally { internal--; }
  };
  const getCart = () => api('cart.js');

  const isGift = it => giftId && it.product_id === giftId;
  const isGuide = it => guideId && it.product_id === guideId;
  const isFree = it => isGift(it) || isGuide(it);
  // All paid items (used for free shipping).
  const paidSubtotal = c => c.items.filter(it => !isFree(it)).reduce((s, it) => s + it.final_line_price, 0);
  // Paid items that count toward the free gifts (same collection as the Shopify discounts).
  const giftSubtotal = c => c.items.filter(it => !isFree(it) && (!eligible.size || eligible.has(it.product_id))).reduce((s, it) => s + it.final_line_price, 0);

  // Keep the free items valid: free pair is capped at 1 and removed below its goal;
  // the guide is added automatically at its goal and removed below it.
  async function enforceGifts(c) {
    changed = false;
    const sub = giftSubtotal(c);
    const updates = {};
    if (giftId) {
      const ok = sub >= threshold;
      c.items.filter(isGift).forEach((g, i) => { const q = ok && i === 0 ? 1 : 0; if (g.quantity !== q) updates[g.key] = q; });
    }
    let addGuide = false;
    if (guideId) {
      const ok = sub >= guideThreshold;
      const guides = c.items.filter(isGuide);
      guides.forEach((g, i) => { const q = ok && i === 0 ? 1 : 0; if (g.quantity !== q) updates[g.key] = q; });
      if (!ok) store.set(GUIDE_OFF, null);
      else if (!guides.length && !store.get(GUIDE_OFF) && cfg.guide.variantId) addGuide = true;
    }
    if (Object.keys(updates).length) { await api('cart/update.js', { updates }); changed = true; }
    if (addGuide) {
      try { await api('cart/add.js', { items: [{ id: cfg.guide.variantId, quantity: 1 }] }); changed = true; }
      catch (_) { /* guide unavailable: skip silently */ }
    }
    return changed ? getCart() : c;
  }

  function setBusy(v) { busy = v; root.classList.toggle('is-busy', v); }
  function showErr(m) { errEl.textContent = m || ''; errEl.style.display = m ? 'block' : 'none'; }

  function updateCount(c) {
    document.querySelectorAll('a[href$="/cart"]').forEach(a => {
      if (!a.closest('.nhd-icons')) return;
      let b = a.querySelector('.nhd-count');
      if (c.item_count > 0) { if (!b) { b = document.createElement('span'); b.className = 'nhd-count'; a.appendChild(b); } b.textContent = c.item_count; }
      else if (b) b.remove();
    });
  }

  function upsellCard(p) {
    const names = (p.options || []).map(o => typeof o === 'string' ? o : o.name);
    const iSize = names.findIndex(n => /size/i.test(n) && !/pack/i.test(n));
    const iColor = names.findIndex(n => /colou?r/i.test(n));
    const iPack = names.findIndex(n => /pack/i.test(n));
    const avail = p.variants.filter(v => v.a);
    if (!avail.length) return '';
    const score = v => (iPack > -1 && /^2\s*pack/i.test(v.o[iPack]) ? 2 : 0) + (iColor > -1 && /^black$/i.test(v.o[iColor]) ? 1 : 0);
    const pick = [...avail].sort((x, y) => score(y) - score(x))[0];
    const group = iSize > -1 ? avail.filter(v => v.o.every((o, i) => i === iSize || o === pick.o[i])) : [pick];
    const pk = iPack > -1 ? pick.o[iPack] : '';
    const packLabel = pk && !/^single$/i.test(pk) ? (pk.match(/^\d+\s*pack/i) || [pk])[0].replace(/pack/i, 'Pack') + ' | ' : '';
    const label = v => iSize > -1 ? v.o[iSize] : v.o.join(' / ');
    const pic = pick.img || p.image;
    return `<div class="nsc__card" data-nsc-up="${p.id}">
      <a href="${esc(p.url)}"><img src="${esc(img(pic))}" alt="" loading="lazy"></a>
      <div class="nsc__info">
        <a class="nsc__t" href="${esc(p.url)}">${esc(packLabel + p.title)}</a>
        <span class="nsc__pr" data-nsc-up-price>${money(group[0].price)}</span>
        <div class="nsc__row">
          <select class="nsc__sel" data-nsc-up-sel aria-label="Size">${group.map(v => `<option value="${v.id}" data-price="${v.price}">${esc(label(v))}</option>`).join('')}</select>
          <button type="button" class="nsc__abtn" data-nsc-up-add>Add</button>
        </div>
      </div>
    </div>`;
  }

  // Progress bar with one milestone per reward (free shipping, free guide, free pair).
  function barHtml(c) {
    const subAll = paidSubtotal(c);
    const sub = giftSubtotal(c);
    const tiers = [];
    if (shipThreshold > 0) tiers.push({ amt: shipThreshold, val: subAll, label: cfg.shipLabel, msg: cfg.msgShipLocked });
    if (guideId && guideThreshold > 0) tiers.push({ amt: guideThreshold, val: sub, label: cfg.guideLabel, msg: cfg.msgGuideLocked });
    if (giftId && threshold > 0) tiers.push({ amt: threshold, val: sub, label: cfg.goalLabel, msg: cfg.msgLocked });
    if (!tiers.length) return '';
    tiers.sort((a, b) => a.amt - b.amt);
    const n = tiers.length;
    const next = tiers.find(t => t.val < t.amt);
    const msg = next ? String(next.msg || '').replace('[amount]', money(next.amt - next.val, true)) : cfg.msgUnlocked;
    // Milestones are evenly spaced; fill moves through each segment.
    let pct = 100, prev = 0;
    for (let i = 0; i < n; i++) {
      const t = tiers[i];
      if (sub >= t.amt) { prev = t.amt; continue; }
      pct = ((i + (sub - prev) / (t.amt - prev)) / n) * 100;
      break;
    }
    const marks = tiers.map((t, i) => `<span class="nsc__mark${t.val >= t.amt ? ' is-on' : ''}" style="left:${((i + 1) / n) * 100}%"></span>`).join('');
    const lbls = tiers.map((t, i) => `<span class="${t.val >= t.amt ? 'is-on' : ''}${i === n - 1 ? ' is-last' : ''}" style="left:${((i + 1) / n) * 100}%"><b>${t.val >= t.amt ? '✓ ' : ''}${esc(money(t.amt, true))}</b>${esc(t.label)}</span>`).join('');
    return `<div class="nsc__bar"><p class="nsc__msg">${esc(msg)}</p><div class="nsc__track"><div class="nsc__fill" style="width:${Math.max(0, Math.min(100, pct))}%"></div>${marks}</div><div class="nsc__lbls">${lbls}</div></div>`;
  }

  // "Choose your size" card for the free pair once it is unlocked.
  function giftCardHtml(c) {
    if (!giftId || !cfg.gift || giftSubtotal(c) < threshold || c.items.some(isGift)) return '';
    const gv = cfg.gift.variants.filter(v => v.available);
    if (!gv.length) return '';
    return `<div class="nsc__gift">
      <img src="${esc(img(cfg.gift.image))}" alt="">
      <div class="nsc__gift-info">
        <p class="nsc__gift-t">${esc(cfg.gift.title)}</p>
        <p class="nsc__gift-p"><s>${money(gv[0].price)}</s><span class="nsc__free">FREE</span></p>
        <div class="nsc__row">
          <select class="nsc__sel" data-nsc-gift-sel aria-label="Gift size"><option value="">Size</option>${gv.map(v => `<option value="${v.id}">${esc(v.title)}</option>`).join('')}</select>
          <button type="button" class="nsc__gbtn" data-nsc-gift-add>+ ADD</button>
        </div>
      </div>
    </div>`;
  }

  // Cart page: show the same bar above the cart.
  let pageBox = null;
  function renderPage(c) {
    if (!onCartPage) return;
    if (!pageBox) {
      const host = document.querySelector('#MainContent [id$="__cart-section"]') || document.querySelector('#MainContent .shopify-section') || document.getElementById('MainContent');
      if (!host) return;
      pageBox = document.createElement('div');
      pageBox.className = 'nsc-page';
      host.insertBefore(pageBox, host.firstChild);
    }
    const paid = c.items.filter(it => !isFree(it));
    pageBox.innerHTML = paid.length ? barHtml(c) + giftCardHtml(c) : '';
  }

  function render(c) {
    cart = c;
    updateCount(c);
    renderPage(c);
    const items = c.items;
    const paid = items.filter(it => !isFree(it));
    const inCart = new Set(items.map(it => it.product_id));
    let html = '';

    if (paid.length) html += barHtml(c) + giftCardHtml(c);

    if (!items.length) {
      html += `<div class="nsc__empty"><p>Your cart is empty</p><a href="${esc(cfg.collectionsUrl || '/collections/all')}">Continue shopping</a></div>`;
    } else {
      html += `<div class="nsc__ih">Your items <span>(${c.item_count})</span></div><ul class="nsc__items">`;
      items.forEach(it => {
        const g = isFree(it);
        const vt = it.variant_title && !/default title/i.test(it.variant_title) ? (isGift(it) ? 'Size: ' : '') + it.variant_title : '';
        const price = g
          ? `<s>${money(it.original_line_price)}</s><span class="nsc__free">FREE</span>`
          : (it.final_line_price < it.original_line_price ? `<s>${money(it.original_line_price)}</s>` : '') + money(it.final_line_price);
        html += `<li class="nsc__item" data-key="${esc(it.key)}">
          <a class="nsc__img" href="${esc(it.url)}">${it.image ? `<img src="${esc(img(it.image))}" alt="" loading="lazy">` : ''}</a>
          <div class="nsc__info">
            <a class="nsc__t" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${vt ? `<p class="nsc__v">${esc(vt)}</p>` : ''}
            <div class="nsc__pr">${price}</div>
            <div class="nsc__act">
              ${g ? '<span></span>' : `<div class="nsc__qty"><button type="button" data-nsc-qty="-1" aria-label="Decrease quantity">&minus;</button><span>${it.quantity}</span><button type="button" data-nsc-qty="1" aria-label="Increase quantity">+</button></div>`}
              <button type="button" class="nsc__rm" data-nsc-rm>Remove</button>
            </div>
          </div>
        </li>`;
      });
      html += '</ul>';
    }

    const ups = (cfg.upsells || []).filter(p => !inCart.has(p.id)).map(upsellCard).filter(Boolean);
    if (ups.length) html += `<div class="nsc__ups"><p>${esc(cfg.upsellTitle)}</p><div class="nsc__slider">${ups.join('')}</div></div>`;

    body.innerHTML = html;
    foot.style.display = items.length ? '' : 'none';
    // Free items are discounted at checkout; show the total the customer will actually pay.
    const freeOwed = items.filter(isFree).reduce((s, it) => s + it.final_line_price, 0);
    totalEl.textContent = money(Math.max(0, c.total_price - freeOwed));
    const disc = (c.cart_level_discount_applications || []).filter(d => d.total_allocated_amount > 0);
    discEl.innerHTML = disc.map(d => `<div class="nsc__ship"><span>Discount (${esc(d.title)})</span><span style="opacity:1;color:var(--sc-free)">-${money(d.total_allocated_amount)}</span></div>`).join('');
  }

  // On the cart page the line items come from the theme, so reload when we change the cart.
  function afterChange(c) {
    if (onCartPage && changed) { location.reload(); return; }
    render(c);
  }

  async function refresh() {
    try { let c = await getCart(); c = await enforceGifts(c); afterChange(c); return c; }
    catch (e) { showErr(e.message); }
  }

  async function run(fn) {
    if (busy) return;
    setBusy(true); showErr('');
    try {
      let c = await fn(); if (!c || typeof c.item_count !== 'number') c = await getCart();
      c = await enforceGifts(c);
      if (onCartPage) { location.reload(); return; }
      render(c);
    }
    catch (e) { showErr(e.message); await refresh(); }
    finally { setBusy(false); }
  }

  let lastFocus = null;
  function open(skipRefresh) {
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nsc-lock');
    if (!skipRefresh || !cart) refresh();
    setTimeout(() => root.querySelector('.nsc__x').focus(), 50);
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nsc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function addGiftFrom(scope) {
    const sel = scope.querySelector('[data-nsc-gift-sel]');
    if (!sel || !sel.value) { sel && sel.focus(); return; }
    run(() => api('cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] }));
  }

  root.addEventListener('click', e => {
    if (e.target.closest('[data-nsc-close]')) { close(); return; }
    const li = e.target.closest('.nsc__item');
    const q = e.target.closest('[data-nsc-qty]');
    if (q && li) {
      const it = cart.items.find(x => x.key === li.dataset.key);
      if (it) run(() => api('cart/change.js', { id: it.key, quantity: Math.max(0, it.quantity + Number(q.dataset.nscQty)) }));
      return;
    }
    if (e.target.closest('[data-nsc-rm]') && li) {
      const it = cart && cart.items.find(x => x.key === li.dataset.key);
      if (it && isGuide(it)) store.set(GUIDE_OFF, '1'); // customer removed the guide: don't add it again
      run(() => api('cart/change.js', { id: li.dataset.key, quantity: 0 }));
      return;
    }
    if (e.target.closest('[data-nsc-gift-add]')) { addGiftFrom(root); return; }
    const add = e.target.closest('[data-nsc-up-add]');
    if (add) {
      const sel = add.closest('.nsc__card').querySelector('[data-nsc-up-sel]');
      run(() => api('cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] }));
      return;
    }
    if (e.target.closest('[data-nsc-checkout]')) { location.href = base + 'checkout'; }
  });
  const onGiftSel = e => {
    if (e.target.matches('[data-nsc-gift-sel]')) {
      const btn = e.target.closest('.nsc__gift').querySelector('[data-nsc-gift-add]');
      if (btn) btn.classList.toggle('is-ready', !!e.target.value);
    }
  };
  root.addEventListener('change', e => {
    onGiftSel(e);
    if (e.target.matches('[data-nsc-up-sel]')) {
      const o = e.target.selectedOptions[0];
      e.target.closest('.nsc__card').querySelector('[data-nsc-up-price]').textContent = money(Number(o.dataset.price));
    }
  });
  // Cart page: free pair card and guide removal.
  if (onCartPage) {
    document.addEventListener('change', e => { if (pageBox && pageBox.contains(e.target)) onGiftSel(e); });
    document.addEventListener('click', e => {
      if (pageBox && e.target.closest('[data-nsc-gift-add]') && pageBox.contains(e.target)) { addGiftFrom(pageBox); return; }
      // Remember when the customer removes the guide from the cart page.
      if (!cart || !guideId) return;
      const rm = e.target.closest('button, a');
      if (!rm || !/remove|delete/i.test((rm.getAttribute('aria-label') || '') + ' ' + (rm.className || '') + ' ' + (rm.getAttribute('href') || ''))) return;
      const row = rm.closest('tr, li, [data-key], [data-cart-item], .cart-items__table-row');
      const guideLine = cart.items.find(isGuide);
      if (row && guideLine && (row.innerHTML.includes(guideLine.url.split('?')[0]) || (row.dataset.key || '') === guideLine.key)) store.set(GUIDE_OFF, '1');
    }, true);
  }
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // Open the drawer from any cart link (except on the cart page itself).
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href]');
    if (!a || onCartPage || root.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey) return;
    let u; try { u = new URL(a.href, location.href); } catch (_) { return; }
    if (u.origin === location.origin && /\/cart\/?$/.test(u.pathname)) { e.preventDefault(); e.stopPropagation(); open(); }
  }, true);

  // NADS product page: add to cart and open the drawer instead of going to /cart.
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-npd-atc]');
    if (!btn || btn.disabled) return;
    const vid = new URL(location.href).searchParams.get('variant');
    if (!vid) return;
    e.preventDefault(); e.stopPropagation();
    const lbl = btn.querySelector('[data-npd-atc-label]');
    const errBox = document.querySelector('[data-npd-err]');
    btn.disabled = true; if (lbl) lbl.textContent = 'Adding…';
    try {
      busy = true;
      await api('cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] });
      busy = false;
      open();
    } catch (err) { busy = false; if (errBox) errBox.textContent = err.message; }
    finally { btn.disabled = false; if (lbl) lbl.textContent = 'Add to cart'; }
  }, true);

  // Watch cart requests made by the theme or apps (not our own).
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = String(input && typeof input === 'object' && input.url ? input.url : input || '');
    const ours = internal > 0;
    const p = origFetch.apply(this, arguments);
    if (!ours) {
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(r => { if (r.ok && !busy && !onCartPage) setTimeout(() => open(), 30); }).catch(() => {});
      } else if (onCartPage && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
        // Cart page quantity/remove: re-check rewards and update the bar.
        p.then(r => { if (r.ok) setTimeout(refresh, 60); }).catch(() => {});
      }
    }
    return p;
  };

  window.NadsCart = { open, close, refresh };
  if (location.hash === '#cart' && !onCartPage) open();
  else refresh();
})();
